import { size } from 'lodash';

import isEmpty from 'Services/helpers/isEmpty';
import isValidMobileNumber from 'Services/helpers/isValidMobileNumber';
import isValidEmailAddress from 'Services/helpers/isValidEmailAddress';
import { EMPTY_OBJ } from 'Services/constants/empty';

const VALID_GENNUM_REGEXP = new RegExp(/^\d{5}$/);

const validate = (value, params = EMPTY_OBJ) => {
  const errors = [];
  if (size(params)) {
    if (params.required && isEmpty(value)) {
      errors.push('required');
    }
    if (params.minLength && size(value) < params.minLength) {
      errors.push(`minLength${params.minLength}`);
    }
    if (params.validMobileNumber && !isValidMobileNumber(value)) {
      errors.push('invalid mobile');
    }
    if (params.validEmailAddress && !isValidEmailAddress(value)) {
      errors.push('invalid email');
    }
    if (params.isValidGenNumber && !VALID_GENNUM_REGEXP.test(value)) {
      errors.push('invalid gennumber');
    }
  }
  if (errors.length) return errors;
  return null;
};

export default validate;
